var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vuestic-icon-responsive",
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 47.5 49" },
    },
    [
      _c("defs"),
      _c("title", [_vm._v("overview_icon_3")]),
      _c("g", { attrs: { id: "Layer_2", "data-name": "Layer 2" } }, [
        _c("g", { attrs: { id: "Layer_1-2", "data-name": "Layer 1" } }, [
          _c("polygon", {
            staticClass: "cls-1",
            attrs: {
              points:
                "37 26 37 7 11 7 11 18 3 18 3 46 11 46 15 46 30 46 37 46 45 46 45 26 37 26",
            },
          }),
          _c("path", {
            staticClass: "cls-2",
            attrs: {
              d: "M40,19V0H8V11H0V49H47.5V19ZM3,46V14H8V46Zm34,0H11V3H37Zm7.5,0H40V22h4.5Z",
            },
          }),
          _c("circle", {
            staticClass: "cls-2",
            attrs: { cx: "24", cy: "41", r: "2.67" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }